import { render } from "./GoogleSsoComp.vue?vue&type=template&id=abc03ad2"
import script from "./GoogleSsoComp.vue?vue&type=script&lang=js"
export * from "./GoogleSsoComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__